import { gql } from '@apollo/client';

export const GET_ACCESS_POLICIES = gql`
  query GetAccessPolicies {
    accessPolicies {
      id
      name
      description
      rules
      users {
        id
        firstName
        lastName
      }
    }
  }
`;
